import React from 'react';
import InputLabel from '../InputLabel'
import './ValueDisplay.scss';

export default function ValueDisplay({ children, value, label })
{
    return (
        <div className='row value-display'>
            <div className='col-12'>
                {
                    label ? 
                        <div className='row'>
                            <div className='col-12'>
                                <InputLabel label={label}/>
                            </div>
                        </div> 
                    : null
                }
                <div className='row'>
                    <div className='col-12'>
                        <span className='value-display'>
                            {children||value}
                        </span>
                    </div>
                </div>
            </div>
        </div>
       
    );
}